import {
  faArrowsRotate,
  faExclamation,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { useParams } from 'react-router';

import Modal from '../../../foundation/components/modal/Modal';
import { useRefreshVariantLogic } from './hooks/useRefreshVariantLogic';

type RefreshVariantDataButtonProps = {
  lastUpdated?: string;
};

const RefreshVariantDataButton = ({
  lastUpdated,
}: RefreshVariantDataButtonProps) => {
  const { vid: variantId } = useParams();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    React.useState(false);

  const { handleRefresh, isLoading, isPreparingSnapshot, hasRunningRefresh } =
    useRefreshVariantLogic(variantId);

  const lastUpdatedDate = lastUpdated?.slice(0, 10);

  return (
    <>
      <div className="variant-summary__refresh-control">
        <Tooltip title="fetches all the latest data and triggers a recalculation of all arguments">
          <button
            type="button"
            className="variant-summary__refresh-button"
            disabled={
              isLoading ||
              isPreparingSnapshot ||
              hasRunningRefresh ||
              !variantId
            }
            onClick={() => setIsConfirmationModalOpen(true)}
            aria-label="fetches all the latest data and triggers a recalculation of all arguments"
          >
            <span className="variant-summary__refresh-icon" aria-hidden="true">
              <FontAwesomeIcon icon={faArrowsRotate} />
              <FontAwesomeIcon icon={faExclamation} />
            </span>
          </button>
        </Tooltip>
        {lastUpdatedDate && (
          <span className="variant-summary__last-update">
            Data fetched on {lastUpdatedDate}
          </span>
        )}
      </div>

      <Modal
        open={isConfirmationModalOpen}
        title="Are you sure you want to UPDATE and RECALCULATE?"
        className="variant-refresh-confirmation"
        footer={
          <div className="variant-refresh-confirmation__footer">
            <Button
              onClick={() => setIsConfirmationModalOpen(false)}
              disabled={isLoading || isPreparingSnapshot}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleRefresh}
              loading={isLoading || isPreparingSnapshot}
            >
              Confirm
            </Button>
          </div>
        }
        onCancel={() => setIsConfirmationModalOpen(false)}
        width={560}
        draggable={false}
        resizable={false}
      >
        <div className="variant-refresh-confirmation__content">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="variant-refresh-confirmation__warning-icon"
            aria-hidden="true"
          />
          <div>
            <div className="variant-refresh-confirmation__headline">
              Attention
            </div>
            <p>
              This action fetches all the latest data and triggers a
              recalculation of all arguments.
            </p>
            <p>
              All stages will return to under revision status, and the
              classification of the variant might change.
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RefreshVariantDataButton;
